import React from "react";
import { WACategoryFileComponent } from "../../Storecast/Storecast/WidgetAdd/Categories/WACategoryFile/WACategoryFile";
import { OrgSpaceWidgetAddScreenProps } from "./OrgSpaceWidgetAddDrawer";
import { useOrgSpaceUnitSize } from "../OrgSpaces/useOrgSpaceUnitSize";

export function OrgSpaceWACategoryFile(
  props: OrgSpaceWidgetAddScreenProps<"OrgSpaceWACategoryFile">
) {
  const unitSize = useOrgSpaceUnitSize();
  return (
    <WACategoryFileComponent
      onAdd={() =>
        props.navigation.navigateDeprecated("OrgSpaceWidgetAddFile", {
          maxSize: props.route.params.maxSize,
          position: props.route.params.position,
          spaceId: props.route.params.spaceId,
          workspaceId: props.route.params.workspaceId,
        })
      }
      maxSize={props.route.params.maxSize}
      unitSize={unitSize}
    />
  );
}
